<header class="topbar">
    <div class="brand">
        <div>
            <div class="brand-name">Immoconn</div>
            <div class="brand-sub">Planung</div>
        </div>
    </div>

    <div class="viewtoggle">
        <button type="button" [class.active]="viewMode === 'map'" (click)="setViewMode('map')">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                 stroke-linejoin="round">
                <path d="M9 3 3 5.5v15L9 18l6 3 6-2.5v-15L15 6 9 3Z"/>
                <path d="M9 3v15M15 6v15"/>
            </svg>
            Karte
        </button>
        <button type="button" [class.active]="viewMode === 'list'" (click)="setViewMode('list')">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                 stroke-linejoin="round">
                <path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/>
            </svg>
            Liste
        </button>
    </div>

    <div class="spacer"></div>
    <div class="kw-chip"><span class="dot"></span>KW <b>{{ getCurrentWeekNumber() }}</b> · <b>{{ sites.length }}</b>
        Liegenschaften
    </div>
    <div class="menu-modal-wrapper">
        <button class="hamburger-btn" (click)="showMenu = !showMenu">
            <i class="ju ju-hamburger_menu"></i>
        </button>
        <div class="menu-modal" *ngIf="showMenu">
            <div class="rows">
                <div class="row" [routerLink]="['/gateway']">Installation App</div>
                <div class="row" [routerLink]="['/planner']">Planungsfunktion</div>
                <div class="row" (click)="openOwnPasswordPopup()">Passwort ändern</div>
                <div class="row" [routerLink]="['/login']">Logout</div>
            </div>
        </div>
    </div>

</header>

<app-planner-map
        *ngIf="viewMode === 'map'"
        [sites]="sites"
        [filter]="currentFilter"
        [customers]="customers"
        [serviceTechnicians]="serviceTechnicians"
        [installationWeekFilterOptions]="installationWeekFilterOptions"
        [statusOptions]="statusOptions"
        (refreshRequested)="loadData($event)">
</app-planner-map>

<app-planner-list
        *ngIf="viewMode === 'list'"
        [sites]="sites"
        [filter]="currentFilter"
        [customers]="customers"
        [serviceTechnicians]="serviceTechnicians"
        [installationWeekFilterOptions]="installationWeekFilterOptions"
        [statusOptions]="statusOptions"
        (refreshRequested)="loadData($event)">
</app-planner-list>
